import { render, staticRenderFns } from "./CourseContentTip.vue?vue&type=template&id=66ba83a8&scoped=true&"
import script from "./CourseContentTip.vue?vue&type=script&lang=js&"
export * from "./CourseContentTip.vue?vue&type=script&lang=js&"
import style0 from "./CourseContentTip.vue?vue&type=style&index=0&id=66ba83a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba83a8",
  null
  
)

export default component.exports